module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"System Quiz"},"en":{"title":"System Quiz"}}')
  delete Component.options._Ctor
}
